import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CustomerServiceFilledSvg from "@ant-design/icons-svg/es/asn/CustomerServiceFilled";
import AntdIcon from '../components/AntdIcon';
var CustomerServiceFilled = function CustomerServiceFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: CustomerServiceFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(CustomerServiceFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'CustomerServiceFilled';
}
export default RefIcon;